<template>
  <mdb-container fluid>
    <FindPhoneUserDataWithCode />
    <mdb-form-inline class="active-cyan active-cyan-2">
      <mdb-btn color="indigo" @click="createNewPatch">{{
        $t("create_new_access_codes")
      }}</mdb-btn>
    </mdb-form-inline>
    <DataTableAG
      deleteparam="accesscodeids"
      :columns="columns"
      width="1600px"
      height="750px"
      archivecontentpath="2.0/newbe/deleteaccesscodes"
      archiveparam="accesscodeids"
      :getcontentpath="getpasswordspath"
      :buttonList="['Muokkaa', 'Luo CSV']"
      jsonobject="passwords"
      :dataUpdate="componentKey"
      :rowHeight="100"
      v-on:pressed-button1="editAccessCode"
      v-on:pressed-button2="fetchPatch"
    />
    <EditProductCodePatch
      v-if="productCodeModal"
      :modal-show="productCodeModal"
      :title="productCodeModalTitle"
      :description="productCodeModalDescription"
      :productCode="productCode"
      :key="componentKey"
      v-on:modal-cancelled="editProductCodeCancelled"
      v-on:modal-ok="editProductCodeOk"
    />
  </mdb-container>
</template>

<script>
import EditProductCodePatch from "@/components/EditProductCodePatch.vue";
import DataTableAG from "@/components/DataTableAG.vue";
import FindPhoneUserDataWithCode from "../components/FindPhoneUserDataWithCode.vue";
import { mdbContainer, mdbBtn, mdbFormInline } from "mdbvue";
import { json2csv } from "json-2-csv";
export default {
  name: "ManagePasswords",
  components: {
    DataTableAG,
    FindPhoneUserDataWithCode,
    EditProductCodePatch,
    mdbContainer,
    mdbBtn,
    mdbFormInline,
  },
  methods: {
    editAccessCode(rowData) {
      this.productCode = rowData;
      this.productCodeModal = true;
    },
    editProductCodeCancelled() {
      this.productCodeModal = false;
    },
    editProductCodeOk() {
      this.productCodeModal = false;
      this.componentKey += 1;
    },
    createNewPatch() {
      this.productCode = {
        count: 0,
        validfrom: "",
        validto: "",
        name: "",
        invalidated: 0,
      };
      this.productCodeModalTitle = this.$t(
        "manage_access_code_new_title_modal"
      );
      this.productCodeModalDescription = this.$t(
        "manage_access_code_new_description_modal"
      );
      this.productCodeModal = true;
    },
    saveFile(text) {
      const blob = new Blob([text], { type: "text/csv;charset=utf-8;" });
      const e = document.createEvent("MouseEvents"),
        a = document.createElement("a");
      a.download = "ProductCodePatch.csv";
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ["text/csv", a.download, a.href].join(":");
      e.initEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      a.dispatchEvent(e);
    },
    createCSV(err, csv) {
      this.saveFile(csv);
    },
    fetchPatch(rowData) {
      this.$notify.info({
        message: this.$t("fetching_content"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium,
      });
      this.$http
        .get(this.retriveaccesscodespatchpath + rowData.id)
        .then((response) => {
          if (response.status == 200) {
            this.rows = response.data.passwords;
            json2csv(this.rows, this.createCSV, this.optionsCSV);
          } else {
            this.$notify.error({
              message: this.$t("content_not_loaded"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
          this.$notify.removeAll();
        })
        .catch((error) => {
          this.$notify.removeAll();
          window.__logAxiosErrorIfDebug(error, {
            context: "ManagePasswords.vue - fetchPatch",
          });
          this.$root.$emit("session_failed");
          return error;
        })
        .finally();
    },
  },
  data: () => ({
    getpasswordspath: "/1.0/front/passwords",
    retriveaccesscodespatchpath: "/1.0/front/password/fetchpatch/",
    productCodeModal: false,
    productCodeModalTitle: "",
    productCodeModalDescription: "",
    productCode: null,
    componentKey: 0,
    dataTableVisible: true,
    optionsCSV: {
      delimiter: {
        field: ";", // Comma field delimiter
      },
    },
    columns: [
      {
        field: "name",
        headerName: "Nimi",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
      },
      {
        field: "invalidated",
        headerName: "Tila",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
      },
      {
        field: "password_count",
        headerName: "Kappalemäärä",
        width: 100,
        pinned: "left",
        sortable: true,
        filter: true,
      },
      {
        field: "id",
        headerName: "Tunniste",
        width: 100,
        pinned: "left",
        sortable: true,
        filter: true,
      },
      {
        field: "password_used_count",
        headerName: "Käytetyt",
        width: 100,
        pinned: "left",
        sortable: true,
        filter: true,
      },
      {
        field: "patchdate",
        headerName: "Luontipäivä",
        width: 200,
        pinned: "left",
        sortable: true,
        filter: true,
      },
      {
        field: "validfrom",
        headerName: "Voimassa alkaen",
        width: 200,
        pinned: "left",
        sortable: true,
        filter: true,
      },
      {
        field: "validto",
        headerName: "Voimassaolo päättyy",
        width: 200,
        pinned: "left",
        sortable: true,
        filter: true,
      },
    ],
  }),
  mounted() {},
};
</script>
